import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import Modal from './Modal.vue'

let el = document.querySelector('#social-view')
if(el) new Vue({
    el,
    components: {
        
    },
    data() {
        return {
            loading: true,
            failed: false,
            feed: [],
        }
    },
    methods: {
        getFeeds() {
            this.loading = true
            this.failed = false
            Promise.all([axios.get(`/wp-json/bowtie/feed`), axios.get(`/wp-json/bowtie/feed?source=twitter`)])
            .then(([instagram, twitter]) => {

                if(instagram.data.data.length > 0) instagram.data.data.forEach(post => {
                    this.feed.push({ created: post.created_time, source: 'instagram', post })
                })

                if(twitter.data.length > 0) twitter.data.forEach(post => {
                    this.feed.push({ created: moment(post.created_at, 'dd MMM DD HH:mm:ss ZZ YYYY').unix(), source: 'twitter', post })
                })

                this.feed.sort((a, b) => {
                    return b.created - a.created
                })

                this.loading = false
            }).catch(() => {
                this.loading = false
                this.failed = true
            })
        },
        getLink(post) {
            if(post.source == 'instagram') {
                return post.post.link
            } else {
                return `https://twitter.com/statuses/${post.post.id_str}`
            }
        },
        getUser(post) {
            if(post.source == 'instagram') {
                return post.post.user.username
            } else {
                return post.post.user.screen_name
            }
        }
    },
    mounted() {
        this.getFeeds()
    }
})



// WEBPACK FOOTER //
// ./assets/js/components/_social.js